import { render, staticRenderFns } from "./landmarkFamily.vue?vue&type=template&id=b0958eb0&scoped=true&"
import script from "./landmarkFamily.vue?vue&type=script&lang=ts&"
export * from "./landmarkFamily.vue?vue&type=script&lang=ts&"
import style0 from "./landmarkFamily.vue?vue&type=style&index=0&id=b0958eb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0958eb0",
  null
  
)

export default component.exports